import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthShell from "@/components/AuthShell";
import GoogleButton from "@/components/GoogleButton";
import { useAuth } from "@/context/AuthContext";

export default function Join() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    const res = await register(name, email, password);
    setLoading(false);
    if (res.ok) navigate("/onboarding");
    else setError(res.error);
  };

  return (
    <AuthShell title="Join the Circle" subtitle="Free forever. No fake numbers, no pressure."
      footer={<>Already a member? <Link to="/signin" className="text-teal font-semibold">Sign in</Link></>}>
      <GoogleButton label="Sign up with Google" />
      <div className="flex items-center gap-4 my-6">
        <span className="h-px flex-1 bg-rose/50" /><span className="text-sm text-mutedplum">or</span><span className="h-px flex-1 bg-rose/50" />
      </div>
      <form onSubmit={submit} className="space-y-4" data-testid="join-form">
        <div>
          <label className="block text-sm font-semibold text-plum mb-1.5">First name</label>
          <input type="text" required value={name} onChange={(e) => setName(e.target.value)} data-testid="join-name"
            className="w-full rounded-2xl border-2 border-rose/50 bg-white px-4 py-3 outline-none focus:border-teal transition-colors" />
        </div>
        <div>
          <label className="block text-sm font-semibold text-plum mb-1.5">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="join-email"
            className="w-full rounded-2xl border-2 border-rose/50 bg-white px-4 py-3 outline-none focus:border-teal transition-colors" />
        </div>
        <div>
          <label className="block text-sm font-semibold text-plum mb-1.5">Password</label>
          <input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="join-password"
            className="w-full rounded-2xl border-2 border-rose/50 bg-white px-4 py-3 outline-none focus:border-teal transition-colors" />
          <p className="mt-1 text-xs text-mutedplum">At least 6 characters.</p>
        </div>
        {error && <p className="text-sm text-red-500" data-testid="join-error">{error}</p>}
        <button type="submit" disabled={loading} data-testid="join-submit"
          className="w-full rounded-full bg-teal px-6 py-3.5 font-semibold text-white hover:bg-teal-dark transition-colors disabled:opacity-60">
          {loading ? "Creating your account…" : "Create my account"}
        </button>
      </form>
    </AuthShell>
  );
}
